import React from 'react'
import {RiFacebookLine} from 'react-icons/ri'
import {CgInstagram} from 'react-icons/cg'
import {RiLinkedinLine} from 'react-icons/ri'
import {GrMailOption} from 'react-icons/gr'
import {Link} from 'react-router-dom'
import {GiSelfLove} from 'react-icons/gi'

const Footer = () => {
  return (
    <>
   <footer className="overflow-hidden  md:px-auto py-6 md:py-8 w-full h-1/6 bg-bgFooter">

    <div className="header">
   <h1 className='text-center text-4xl'>
    Follow Me
   </h1>
    </div>
    
    
    <div className="text-center md:px-0 md:mx-auto">
             <div className="flex flex-row justify-center text-2xl md:text-4xl space-x-6 md:space-x-12">
             <a href='https://www.facebook.com/santosh.kharel.33/' target="_blank" rel="noreferrer" className='w-10 p-8 '><RiFacebookLine/></a>
             <a href='https://www.instagram.com/kharel13/' target="_blank" rel="noreferrer" className='w-10 p-8 '><CgInstagram/></a>
             <a href='https://www.linkedin.com/in/santosh-kharel-a67a17217/'  target="_blank" rel="noreferrer" className='w-10 p-8 '><RiLinkedinLine/></a>
             <a href='mailto:santoshkharel9684@gmail.com' target="_blank" rel="noreferrer" className='w-10 p-8 '><GrMailOption/></a>
             </div>
             </div>

             <p className="text-center">Copyright &copy; 2022 All rights reserved | Made with bit of React, Tailwind, Node js & tons of <span className="text-red-600 max-w-2 inline-block"><GiSelfLove/></span> by <span className="text-blue-600 ">Santosh Kharel</span></p>
   </footer>
   
   </>
  )
}

export default Footer